<template>
  <div>
    <div class="pb-4">
      <PageHeader title="مدیریت دوره" :items="pageHeaderItems" />
    </div>
    <TabLink :items="links">
      <div v-if="!$route.path.includes('faculty')" class="d-flex">
        <b-button
          variant="danger"
          :class="{ disable: model.status !== 1 }"
          class="px-4"
          @click="
            $bvModal.show('reject')
            model.licenseStatus = 3
          "
          >رد</b-button
        >
        <b-button
          variant="primary"
          :class="{ disable: model.status !== 1 }"
          class="ms-2"
          @click="
            $bvModal.show('edit')
            model.licenseStatus = 2
          "
          >نیاز به اصلاح</b-button
        >
        <b-button
          variant="success"
          :class="{ disable: model.status !== 1 }"
          class="px-5 ms-2"
          @click="
            model.licenseStatus = 4
            changeStaus()
          "
          >تایید</b-button
        >
      </div>
      <b-button v-else variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest"> درخواست مجوز دوره</b-button>
    </TabLink>
    <div v-if="$route.fullPath !== '/list/universitycourses/add' && $route.fullPath !== '/list/facultyuniversitycourses/add' && !$route.params.courseId" class="card p-3">
      برای اضافه کردن این بخش ابتدا باید دوره را ثبت نمایید
    </div>
    <div v-else-if="$route.path.includes('/users') && model.status != 4" class="card p-3">جهت مدیریت اعضا، ابتدا میبایست دوره تایید گردد.</div>
    <router-view v-else></router-view>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="reject" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title> رد درخواست</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت رد درخواست"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
          :required="true"
          :showError="submit && !model.description"
          errortext="وارد کردن علت رد درخواست الزامی است."
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="edit" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>نیاز به اصلاح</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت نیاز به اصلاح"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import TabLink from '../../../components/common/TabLink.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import moocCourseProvider from '../../../services/mooc/course'
import moocCourseSessionProvider from '../../../services/mooc/healline'
export default {
  page: {
    title: 'مدیریت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-courses',
  components: {
    TabLink,
    PageHeader,
    TextAreaInput,
    Toast,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      currentAvailableStatus: {},
      model: {
        productId: +this.$route.params.courseId,
        productType: 0,
        licenseStatus: 0,
        description: '',
      },
      error: false,
      message: '',
      addedHeadlines: false,
      submit: false,
    }
  },
  computed: {
    isFaculty() {
      return false
    },
    links() {
      if (this.$route.params.courseId !== undefined) {
        return [
          {
            title: 'ایجاد درس',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyuniversitycourses/detail/${this.$route.params.courseId}`
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/universitycourses/detail/${this.$route.params.courseId}`
                : this.$route.path.includes('faculty')
                ? '/list/facultyuniversitycourses/add'
                : '/list/universitycourses/add',
            disable: this.isFaculty,
          },
          {
            title: 'سرفصل ها',
            link: this.$route.path.includes('faculty')
              ? `/list/facultyuniversitycourses/${this.$route.params.courseId}/headlines?status=${this.model.status}`
              : `/list/universitycourses/${this.$route.params.courseId}/headlines`,
            disable: this.isFaculty,
          },

          {
            title: 'اعضا',
            link: this.$route.path.includes('faculty')
              ? `/list/facultyuniversitycourses/${this.$route.params.courseId}/users?status=${this.model.status}&pageNumber=1&perPage=20`
              : `/list/universitycourses/${this.$route.params.courseId}/users?pageNumber=1&perPage=20`,
            disable: this.isFaculty,
          },
        ]
      }
      return [
        { title: 'ایجاد درس', link: this.$route.path.includes('faculty') ? '/list/facultyuniversitycourses/add' : '/list/universitycourses/add' },
        { title: 'سرفصل ها', link: '#' },
        { title: 'اعضا', link: '#' },
      ]
    },
  },
  methods: {
    async sendRequest() {
      await this.checkAddedHeadlines()
      if (this.addedHeadlines) {
        this.model.licenseStatus = 1
        this.changeStaus()
      }
    },
    async fetchAvailableStatus() {
      if (this.$route.params.courseId) {
        const req = await moocCourseProvider.getAvailableStatus({
          productId: +this.$route.params.courseId,
          productType: 0,
        })
        if (req.status === 200) {
          this.model = req.data.data.output
          delete this.model.availableStatus
        }
      }
    },
    async checkAddedHeadlines() {
      const req = await moocCourseSessionProvider.getCourseSession(+this.$route.params.courseId)
      if (req.data && req.data.data.output.length) {
        this.addedHeadlines = true
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست ابتدا باید سرفصل ها را اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async changeStaus() {
      this.submit = true
      if ((this.model.licenseStatus == 2 || this.model.licenseStatus == 3) && !this.model.description) {
        return false
      }
      const req = await moocCourseProvider.updateAvailableStatus({
        productId: +this.$route.params.courseId,
        productType: 0,
        licenseStatus: +this.model.licenseStatus,
        description: this.model.description,
      })
      if (req?.data?.data?.isSuccessful) {
        this.message = 'وضعیت با موفقیت تغییر یافت.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        this.fetchAvailableStatus()
      } else {
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        setTimeout(() => {
          this.error = false
        }, 5000)
      }
    },
  },
  watch: {
    '$route.path'() {
      this.fetchAvailableStatus()
    },
  },
  mounted() {
    this.fetchAvailableStatus()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal.show .modal-dialog {
  min-width: 611px !important;
  width: 611px !important;
}

// ::v-deep .modal-body {
//   min-height: 400px !important;
// }

.disable {
  background: #ced4da;
  pointer-events: none;
  border-color: #ced4da;
}
</style>
